import { render, staticRenderFns } from "./ReminderStatic.vue?vue&type=template&id=953dbe52"
import script from "./ReminderStatic.vue?vue&type=script&lang=js"
export * from "./ReminderStatic.vue?vue&type=script&lang=js"
import style0 from "./ReminderStatic.vue?vue&type=style&index=0&id=953dbe52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports